var ErrCode;
(function (ErrCode) {
    /** Invalid object reference */
    ErrCode["invalidIds"] = "001";
    /** All instances are not within the same organization */
    ErrCode["plotCrossOrganizationRelation"] = "002";
    /** Invalid date range */
    ErrCode["invalidDateRange"] = "010";
    /** Invalid time span */
    ErrCode["invalidDateSpan"] = "011";
    /** Not a valid PointField */
    ErrCode["invalidPointField"] = "012";
    /** No documentation */
    ErrCode["invalidHeader"] = "013";
    /** No documentation */
    ErrCode["invalidUrlParams"] = "014";
    /** No documentation */
    ErrCode["systemMobileDeviceLimitReached"] = "020";
    /** You do not have permission to perform this action. */
    ErrCode["userUnverifiedEmail"] = "101";
    /** You do not have permission to perform this action. */
    ErrCode["userUnknownEmail"] = "102";
    /** Unable to log in with provided credentials. */
    ErrCode["userUnableToLogWithProvidedCredentials"] = "103";
    /** No documentation */
    ErrCode["userMagicLoginUserDoesNotExist"] = "104";
    /** Edge case when users are created manually and they trie to reset their password or get a magic link */
    ErrCode["noAccountAssociatedWithEmail"] = "104_1";
    /** No documentation */
    ErrCode["userMagicLoginNoTokenFound"] = "105";
    /** The given country (from country_cod) is not covered by Weenat */
    ErrCode["countryNotCovered"] = "110";
    /** The given phone number isn't compatible with the given country code */
    ErrCode["numberIncompatibleWithCountryCode"] = "111";
    /** The current user has too many phone numbers (based on his plan) */
    ErrCode["tooManyPhoneNumbers"] = "112";
    /** The current user has duplicated phone numbers */
    ErrCode["duplicatedPhoneNumber"] = "113";
    /** The current user has no phone set as primary */
    ErrCode["primaryPhoneNumberMissing"] = "114";
    /** The user has more than one primary phone number */
    ErrCode["tooManyPrimaryPhoneNumbers"] = "115";
    /** Not sole member. */
    ErrCode["orgNotSoleMember"] = "201";
    /** Owner cannot leave organization. */
    ErrCode["orgOwnerCannotLeaveOrg"] = "202";
    /** Organization has already an owner. */
    ErrCode["orgDuplicateOwner"] = "203";
    /** no_write_rights */
    ErrCode["orgNoWriteRights"] = "204";
    /** User can not see the selected organization */
    ErrCode["orgRulePermmissionDenied"] = "205";
    /** Missing/Invalid SIRET */
    ErrCode["orgMissingSiret"] = "220";
    /** An org located in a country without subsidiary is missing a vat number */
    ErrCode["missingOrInvalidVatNumber"] = "220_01";
    /** Organization does not exist */
    ErrCode["orgDoesNotExist"] = "221";
    /** This organization has already benefited a trial membership with this network */
    ErrCode["orgAlreadyWithATrialContract"] = "223";
    /** Ownership transfer is only allowed towards member of the organization */
    ErrCode["orgOwnershipTransferNotAllowed"] = "224";
    /** Org member already member of this organization */
    ErrCode["orgMemberAlreadyMemberOfThisOrganization"] = "225";
    /** Org not under the required plan */
    ErrCode["orgPlanNotAllowed"] = "226";
    /** Updating the org customer failed */
    ErrCode["orgCustomerUpdate"] = "227_00";
    /** Updating the org customer (odoo) failed */
    ErrCode["orgCustomerOdooUpdate"] = "227_01";
    /** No documentation */
    ErrCode["siretAlreadyUsed"] = "228";
    /** Resource is not active */
    ErrCode["plotInvalidActionOnArchivedPlot"] = "301";
    /** Active cycle not yet completed */
    ErrCode["cropDuplicateActiveCycle"] = "310";
    /** Missing station id */
    ErrCode["missingStation"] = "320";
    /** Missing mandatory metrics */
    ErrCode["missingMetrics"] = "321";
    /** You try to add some plots on which you are not editor */
    ErrCode["plotEditingNotAllowed"] = "322";
    /** You try to add some device_org that you are not allowed to see */
    ErrCode["plotNotAllowedToAddThisDeviceOrgRel"] = "323";
    /** No documentation */
    ErrCode["plotNoDevicePlotRelation"] = "324";
    /** Only organization owner can leave a network */
    ErrCode["nwOnlyOwnerCanLeaveNetwork"] = "401";
    /** This organization is already member of a network */
    ErrCode["orgAlreadyMemberOfANetwork"] = "402";
    /** Unable to invite a user who owns several organisations */
    ErrCode["nwOwnerOrgAlreadyMemberOfMultipleOrg"] = "403";
    /** Only the owner is allowed to request membership */
    ErrCode["nwOnlyOwnerCanRequestMembership"] = "404";
    /** A network cannot request network membership to another network */
    ErrCode["nwCannotRequestNwMembership"] = "405";
    /** A request has already been sent to this network for organization */
    ErrCode["nwRequestAlreadySent"] = "406";
    /** Can't request network membership to network, the requested organization is not premium. */
    ErrCode["nwCannotRequestOrgIfNotPremium"] = "407";
    /** The email from invitation doesn't exist in the database (mainly for community network as they cannot request the creation of an account when inviting someone to their network) */
    ErrCode["invitedEmailDoesNotExist"] = "407_1";
    /** This organization does not currently belong to the network */
    ErrCode["nwOrgDoesNotBelongToTheNw"] = "408";
    /** This organization is not in trial */
    ErrCode["nwOrgNotInTrial"] = "409";
    /** Only the owner can accept Network invitation */
    ErrCode["invOnlyOwnerAcceptNwInvitation"] = "450";
    /** You cannot select this organization as it is a network */
    ErrCode["invOrgAlreadyANetwork"] = "451";
    /** A freemium organization can't accept a community network membership request */
    ErrCode["invFreemiumOrgCannotAcceptCommNwInvit"] = "452";
    /** Invitation already handled */
    ErrCode["invInvitationAlreadyHandled"] = "453";
    /** No documentation */
    ErrCode["invTypeDoesNotExist"] = "454";
    /** Object already premium */
    ErrCode["duplicatePremiumRequest"] = "501";
    /** No documentation */
    ErrCode["licenceCodeDoesNotExist"] = "501_01";
    /** No documentation */
    ErrCode["licenceAlreadySubscribed"] = "501_02";
    /** No customer provided */
    ErrCode["noCustomerProvided"] = "502";
    /** ODOO bad request */
    ErrCode["odooBadRequest"] = "503";
    /** ODOO object not found */
    ErrCode["odooObjectNotFound"] = "504";
    /** Missing billing header */
    ErrCode["billingHeaderMissing"] = "505";
    /** Billing rule failed */
    ErrCode["billingRuleFailed"] = "506";
    /** Invalid billing header */
    ErrCode["billingHeaderInvalid"] = "507";
    /** Quota per organization reached */
    ErrCode["quotaSmvActivationReached"] = "508";
    /** No documentation */
    ErrCode["quotaPlotReached"] = "508_01";
    /** No documentation */
    ErrCode["multipleContract"] = "509";
    /** Option validation: mutually exclusive targets */
    ErrCode["optMutuallyExclusiveArg"] = "510";
    /** Option and payload doesn't match option configuration */
    ErrCode["optParamInputMismatch"] = "511";
    /** Option activation and payload doesn't match any activation flow known. */
    ErrCode["optUnknownAction"] = "512";
    /** Option not supported */
    ErrCode["optNotSupported"] = "513";
    /** Insufficient credit */
    ErrCode["optInsufficientCredit"] = "514";
    /** Try activating twice the same option on an object. */
    ErrCode["optDuplicateActivation"] = "515";
    /** Must be activated first on organization */
    ErrCode["optOrgActivationFirst"] = "516";
    /** Missing approval to purchase an option. */
    ErrCode["optMissingApproval"] = "517";
    /** Error Option activation not allowed with SMD */
    ErrCode["optNotAllowedWithSmd"] = "518";
    /** Missing Movida reseller in option settings */
    ErrCode["optMissingMovidaReseller"] = "519";
    /** Missing water balance config */
    ErrCode["wbMissingConfig"] = "520_01";
    /** Missing water balance seed config in plot meta */
    ErrCode["wbMissingSeedConfig"] = "521_01";
    /** Wrong water balance seed config in plot meta */
    ErrCode["wbWrongSeedConfig"] = "521_02";
    /** Wrong water balance stage */
    ErrCode["wbWrongStage"] = "522_01";
    /** Missing water balance soil type */
    ErrCode["wbMissingSoilType"] = "523_01";
    /** Wrong water balance soil type */
    ErrCode["wbWrongSoilType"] = "523_02";
    /** Missing water balance seed stage config in plot meta */
    ErrCode["wbMissingSeedStageConfig"] = "524_01";
    /** Unknown water balance seed stage config in plot meta */
    ErrCode["wbUnknownSeedStage"] = "524_02";
    /** Missing water balance seed vigilance config */
    ErrCode["wbMissingSeedVigilanceConfig"] = "525_01";
    /** Missing water balance seed stress config */
    ErrCode["wbMissingSeedStressConfig"] = "525_02";
    /** Missing water balance cycle */
    ErrCode["wbMissingCycle"] = "526_01";
    /** Wrong water balance seed date config */
    ErrCode["wbWrongSeedDate"] = "527_01";
    /** Wrong water balance ru */
    ErrCode["wbWrongRu"] = "528_01";
    /** Invalid input. */
    ErrCode["irrinovWrongConfig"] = "530";
    /** Irrinov config wrong cycle */
    ErrCode["irrinovWrongCycleConfig"] = "530_01";
    /** Irrinov config wrong region */
    ErrCode["irrinovWrongRegionConfig"] = "530_02";
    /** Irrinov config wrong soil type */
    ErrCode["irrinovWrongSoilTypeConfig"] = "530_03";
    /** Irrinov config wrong potato type */
    ErrCode["irrinovWrongPotatoTypeConfig"] = "530_04";
    /** Irrinov config wrong water turn */
    ErrCode["irrinovWrongWaterTurnConfig"] = "530_05";
    /** Irrinov wrong stage config */
    ErrCode["irrinovWrongStage"] = "531";
    /** Error thresholds update */
    ErrCode["thresholdsUpdateError"] = "532";
    /** Cannot link a plot to a threshold profile if it already has one */
    ErrCode["plotAlreadyHasCustomThresholds"] = "532_01";
    /** Irritensio capacitive error texture */
    ErrCode["irritensioCapaTexture"] = "533";
    /** Irrinov missing config */
    ErrCode["irrinovMissingConfig"] = "534_01";
    /** Irrinov missing region config */
    ErrCode["irrinovMissingRegionConfig"] = "534_02";
    /** Irrinov missing soil type config */
    ErrCode["irrinovMissingSoilTypeConfig"] = "534_03";
    /** Irrinov missing potato type config */
    ErrCode["irrinovMissingPotatoTypeConfig"] = "534_04";
    /** Irrinov missing water turn config */
    ErrCode["irrinovMissingWaterTurnConfig"] = "534_05";
    /** Invalid input. */
    ErrCode["maizyWrongConfig"] = "540";
    /** Deactivate crop tracking with maizy activated */
    ErrCode["maizyDeactivateCropTracking"] = "541";
    /** Maizy compute stage error */
    ErrCode["maizyComputeStage"] = "542";
    /** Maizy missing config */
    ErrCode["maizyMissingConfig"] = "543_01";
    /** Maizy missing dry matter target */
    ErrCode["maizyMissingDryMatterTarget"] = "543_02";
    /** Missing seed config */
    ErrCode["maizyMissingSeedConfig"] = "543_03";
    /** No soil texture */
    ErrCode["maizyNoSoilTexture"] = "544";
    /** Wrong seed */
    ErrCode["maizyWrongSeed"] = "545";
    /** Invalid cycle */
    ErrCode["maizyInvalidCycle"] = "546";
    /** No seedling date */
    ErrCode["maizyNoSeedingDate"] = "547";
    /** Invalid cumulative sum config */
    ErrCode["cumulativeSumWrongConfig"] = "550";
    /** Invalid cumulative degree day sum span */
    ErrCode["cumulativeSumWrongSpan"] = "551";
    /** Decitrait option not activated */
    ErrCode["decitraitNotActive"] = "560";
    /** Decitrait option not validated */
    ErrCode["decitraitNotValidated"] = "561";
    /** Decitrait option organization not configured */
    ErrCode["decitraitOrganizationNotConfigured"] = "562";
    /** Decitrait option account not configured */
    ErrCode["decitraitAccountNotConfigured"] = "563";
    /** Decitrait option plot not configured */
    ErrCode["decitraitPlotNotConfigured"] = "564";
    /** Decitrait login already associated with another organization */
    ErrCode["decitraitAlreadyLinkedLogin"] = "565b";
    /** No documentation */
    ErrCode["decitraitAuthenticationError"] = "566";
    /** Invalid template stage for the given cycle */
    ErrCode["cropCycleInvalidTemplateStage"] = "570";
    /** Error duplicated default crop seed */
    ErrCode["cropDuplicateDefaultSeed"] = "571";
    /** Error in the Tavmills DSS configuration, could be a missing crop or a missing cycle */
    ErrCode["tavmillsOadConfiguration"] = "580";
    /** Error while computing the DSS results */
    ErrCode["tavmillsOadComputing"] = "581";
    /** For tavmills while crop tracking hasn't reach a specific step the back-end won't compute results*/
    ErrCode["tavmillsOadStageNotActivated"] = "582";
    /** The device has not sufficient data yet (to activate an option like mileos for example) */
    ErrCode["insufficientDeviceData"] = "590";
    /** Device (and its serial) does not exist. */
    ErrCode["deviceDoesNotExist"] = "600";
    /** Missing tensiometer horizon */
    ErrCode["deviceMissingTensiometerHorizon"] = "601";
    /** Device is already in database. Should not happen to a user */
    ErrCode["deviceAlreadyInDb"] = "602";
    /** Device is already in use in another organization. */
    ErrCode["deviceAlreadyInUse"] = "603";
    /** Device metrics (unless it's a tensiometer) overlap with active device-plot-configs */
    ErrCode["deviceMetricsConflictWithDevicePlotConfig"] = "603_01";
    /** The device is already part of the current org */
    ErrCode["deviceAlreadyInCurrentOrg"] = "603_02";
    /** The device is already part of a network the user has access to */
    ErrCode["deviceAlreadyInAccessibleNetwork"] = "603_03";
    /** No documentation */
    ErrCode["deviceConfigUpdate"] = "604";
    /** No documentation */
    ErrCode["deviceConfigUpdateDeviceOrgConflict"] = "604_01";
    /** No documentation */
    ErrCode["deviceConfigUpdatePlotRelConflict"] = "604_02";
    /** No documentation */
    ErrCode["deviceConfigUpdateMetricsConflict"] = "604_03";
    /** Device cannot be added to plot or to the org (ex: trying to add an irrigation sensor on a W+ org) */
    ErrCode["deviceIncompatibleWithPlanOrPlot"] = "605";
    /** No documentation */
    ErrCode["deviceConfigHorizon"] = "606";
    /** The device used to create the station is already assigned to a station on the selected organization */
    ErrCode["stationAlreadyExistInOrg"] = "607";
    /** The user doesn't have the necessary rights to create a station */
    ErrCode["notAllowedToCreateStation"] = "607_01";
    /** config' dictionary has not the right structure for alert type */
    ErrCode["alertConfigType"] = "610";
    /** No soil texture available on plot */
    ErrCode["alertConfigSoilTextureUnavailable"] = "611";
    /** "type" is required */
    ErrCode["alertConfigTypeRequired"] = "612";
    /** This alert 'type' is not already implemented */
    ErrCode["alertTypeNotImplemented"] = "613";
    /**No organization could be found for the consumption of an SMS token */
    ErrCode["notifSmsRequiresOrg"] = "620";
    /** The data field must be a dict (for instance: {"IRR": 1.2}). */
    ErrCode["reportMeasurementFormatError"] = "700_00";
    /** The only keys allowed are: */
    ErrCode["reportMeasurementKeyError"] = "700_01";
    /** The key value must be a number. key: */
    ErrCode["reportMeasurementValueError"] = "700_02";
    /** Export currently being processed */
    ErrCode["exportInProcess"] = "701";
    /** Export link already exist - The same export has been asked in less than 24h */
    ErrCode["exportLinkAlreadyExist"] = "701_01";
    /** Connection error to smag server */
    ErrCode["smagConnectionError"] = "800";
    /** Can't parse smag response */
    ErrCode["smagParseError"] = "801";
    /** Smag server returned invalid status code */
    ErrCode["smagStatusCodeError"] = "802";
    /** Could not validate JWS */
    ErrCode["smagInvalidJwsError"] = "803";
    /** User not associated to a smag account */
    ErrCode["smagUserNotAssociatedError"] = "804";
    /** Can't retrieve smag public keys */
    ErrCode["smagPublicKeysError"] = "805";
    /** Invalid CSRF token */
    ErrCode["smagCsrfError"] = "806";
})(ErrCode || (ErrCode = {}));
export default ErrCode;
